import { calcCollectionCostGen, money } from './common.js';
const selfCollectionCosts = {
    tiers: [
        {
            from: 0,
            to: 1000,
            value: () => money(250),
        },
        {
            from: 1001,
            to: 2500,
            value: () => money(450),
        },
        {
            from: 2501,
            to: 5000,
            value: () => money(550),
        },
        {
            from: 5001,
            to: 10000,
            value: () => money(750),
        },
        {
            from: 10001,
            to: 25000,
            value: () => money(1000),
        },
        {
            from: 25001,
            to: 50000,
            value: () => money(1200),
        },
        {
            from: 50001,
            to: 100000,
            value: () => money(1600),
        },
        {
            from: 100001,
            to: 250000,
            value: () => money(2200),
        },
        {
            from: 250001,
            to: 500000,
            value: () => money(3650),
        },
        {
            from: 500001,
            value: (n) => Math.round(money(3650) + money(Math.max(0, n - 500000)) * 0.0067),
        },
    ],
};
const foreignCollectionCosts = {
    tiers: [
        {
            from: 0,
            to: 1000,
            value: () => money(350),
        },
        {
            from: 1001,
            to: 2500,
            value: () => money(600),
        },
        {
            from: 2501,
            to: 5000,
            value: () => money(850),
        },
        {
            from: 5001,
            to: 10000,
            value: () => money(1100),
        },
        {
            from: 10001,
            to: 25000,
            value: () => money(1450),
        },
        {
            from: 25001,
            to: 50000,
            value: () => money(1950),
        },
        {
            from: 50001,
            to: 100000,
            value: () => money(2450),
        },
        {
            from: 100001,
            to: 250000,
            value: () => money(3300),
        },
        {
            from: 250001,
            to: 500000,
            value: () => money(5500),
        },
        {
            from: 500001,
            value: (n) => Math.round(money(5500) + money(Math.max(0, n - 500000)) * 0.01),
        },
    ],
};
export const calcCollectionCosts = calcCollectionCostGen(selfCollectionCosts, foreignCollectionCosts);
//# sourceMappingURL=greenland.js.map